import { httpRequest } from 'http'
import { sendErrorNotification } from 'helpers/web_to_client'

export const ACCOUNT_INFO_REQUEST = 'account/REQUEST'
export const ACCOUNT_INFO_SUCCESS = 'account/SUCCESS'
export const ACCOUNT_INFO_ERROR = 'account/ERROR'
export const ACCOUNT_STATS_REQUEST = 'account/stats/REQUEST'
export const ACCOUNT_STATS_SUCCESS = 'account/stats/SUCCESS'
export const ACCOUNT_STATS_ERROR = 'account/stats/ERROR'

export function requestSuccess(resp) {
    const {
        id,
        clan,
        role,
        flags,
        permissions,
        periphery_id,
        periphery_name,
        available_features,
        elo_leaderboards,
    } = resp

    return {
        type: ACCOUNT_INFO_SUCCESS,
        payload: {
            id,
            clan,
            role,
            flags,
            permissions,
            periphery_id,
            periphery_name,
            available_features,
            elo_leaderboards,
        },
    }
}

export function requestError(errorData) {
    sendErrorNotification(errorData)
    return {
        type: ACCOUNT_INFO_ERROR,
        payload: errorData,
    }
}

export function requestStatsError(errorData) {
    sendErrorNotification(errorData)
    return {
        type: ACCOUNT_STATS_ERROR,
        payload: errorData,
    }
}

export function requestAccountStatsSuccess(resp) {
    const {
        account_fame_points,
        chevron,
        spare_parts,
        clan_fame_points,
    } = resp

    return {
        type: ACCOUNT_STATS_SUCCESS,
        payload: {
            account_fame_points,
            chevron,
            spare_parts,
            clan_fame_points,
        },
    }
}

export function requestAccountStats() {
    return async (dispatch, getState) => {
        if (getState().account.loadingStats) {
            return
        }
        dispatch({ type: ACCOUNT_STATS_REQUEST })

        const url = `${window.config.WGCG_API_URL}/wgshevents/account/stats`

        if (process.env.API_ENV === 'mock') {
            return dispatch(requestAccountStatsSuccess(require('../__mocks__/account_stats_mock').data))
        }

        httpRequest(url)
            .then(
                resp => {
                    dispatch(requestAccountStatsSuccess(resp))
                },
                errorData => dispatch(requestStatsError(errorData))
            )
    }
}


export default function requestAccountInfo() {
    return async (dispatch, getState) => {
        if (getState().account.loading) {
            return
        }
        dispatch({ type: ACCOUNT_INFO_REQUEST })

        httpRequest('/game_api/account_info')
            .then(
                resp => {
                    window.__WGSH_GA_ROLE__ = resp.role
                    dispatch(requestSuccess(resp))
                },
                errorData => dispatch(requestError(errorData))
            )
    }
}


// WEBPACK FOOTER //
// ./state/actions/account.js